import React from 'react'
import styled from '@emotion/styled'

import { fontSizeXSmall, fontSize2XSmall, fontSize3XSmall, fontWeightBold, fontWeightRegular, fontWeightSemibold, highlightBlueBase } from '../../../constants/principles'
import Icon from './ImageIcon'
import * as Icons from '../../compiledSVG/icon'

export default ({ title = '', subtitle = '', disclaimer = '', showPhotoGuidelinesModal, photoSection, ...props }) => {
  const photoSectionArray = Object.values(photoSection)
  const newProps = { showPhotoGuidelinesModal, ...props }
  return (
    <>
      {title && (
        <StyledHeader fontSize={fontSizeXSmall} fontWeight={fontWeightBold}>
          {title}
        </StyledHeader>
      )}
      {subtitle && (
        <StyledHeader fontSize={fontSize2XSmall} fontWeight={fontWeightRegular}>
          {subtitle}
        </StyledHeader>
      )}
      {disclaimer && (
        <StyledHeader fontSize={fontSize3XSmall} fontWeight={fontWeightRegular}>
          {disclaimer}
        </StyledHeader>
      )}
      <StyledDiv>
        <span data-testid={`vc-txt-see-photo-guidelines`} onClick={showPhotoGuidelinesModal}>See photo guidelines</span>
      </StyledDiv>
      <IconDiv>
        {photoSectionArray.map((section, idx) => {
          return <Icon svg={Icons[section.category.toLowerCase()]} name={section.name} id={section.name} testId={`vc`} key={idx} category={section.category} data={section} {...newProps} />
        })}
      </IconDiv>
    </>
  )
}

const IconDiv = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin: auto;
  max-width: 480px;
  width: 100%;
`
const StyledHeader = styled.header`
  background: none;
  font-size: ${p => p.fontSize};
  font-weight: ${p => p.fontWeight};
  margin: 8px 0;
`

const StyledDiv = styled.div`
  margin-bottom: 30px;
  span {
    color: ${highlightBlueBase};
    font-size: ${fontSize2XSmall};
    font-weight: ${fontWeightSemibold};
    outline: none;
    cursor: pointer;
    :hover {
      text-decoration: underline;
    }
  }
`
